import { useState } from "react"
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { getSharingLink } from "routes/sharing/controller/get-sharing-link"
import { hasVisibleHtmlContent } from "./share-link-html"
import { ShareLinkIntroduction } from "./share-link-introduction"

// Recipient-facing introduction shown above the facilities grid, rendered with the same plain
// collapsible accordion optimiser uses for "Rule Details" on the rule-set page. Starts
// expanded and toggles on click.
export function ShareLinkIntroductionLandingPanel() {
    const { isShare } = useBoundContext()
    const [shareLinkId] = useSearchParam("share", null)
    const shareLink = getSharingLink.useResults(shareLinkId)
    const hasIntroduction = hasVisibleHtmlContent(shareLink?.introductionHtml)
    const [expanded, setExpanded] = useState(true)

    if (!shareLinkId && !isShare) return null
    if (!shareLink || !hasIntroduction) return null

    return (
        <Box data-cy="share-link-introduction-landing-panel">
            <Accordion
                data-cy="share-link-introduction-accordion"
                expanded={expanded}
                onChange={handleToggle}
                disableGutters
                elevation={0}
                square
                sx={{
                    border: "none",
                    bgcolor: "transparent",
                    boxShadow: "none !important",
                    "&:before": { display: "none" },
                    "&.Mui-expanded": { boxShadow: "none !important", borderRadius: 0, margin: 0 },
                }}
            >
                <AccordionSummary
                    expandIcon={<Iconify icon="mingcute:down-line" width={24} />}
                    sx={{ px: 2, py: 1.5, minHeight: 0, "& .MuiAccordionSummary-content": { my: 0 } }}
                >
                    <Typography variant="subtitle1" data-cy="share-link-introduction-title">
                        Introduction
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ px: 2, pt: 0, pb: 2 }}>
                    <ShareLinkIntroduction html={shareLink?.introductionHtml} />
                </AccordionDetails>
            </Accordion>
            <Divider sx={{ mx: 2 }} />
        </Box>
    )

    function handleToggle(_, isExpanded) {
        setExpanded(isExpanded)
    }
}
